<template>
  <v-container fluid>
    <v-dialog v-model="detail" max-width="800px">
        <v-card v-if="detailItem">
          <v-card-title>
            <h4>Detalles de registro</h4>

          </v-card-title>
          <v-card-text>

            <v-layout row mt-2>
                <v-flex xs12>
                    <h6 class="grey--text">Datos del Equipo</h6>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 sm3 class="input-group">
                    <label>Nombre</label>
                    <p>
                      {{ detailItem.team_name }}
                    </p>
                </v-flex>
                <v-flex xs12 sm3 class="input-group">
                    <label>Liga local</label>
                    <p>
                      {{ detailItem.team_league }}
                    </p>
                </v-flex>

                <v-flex xs12 sm3 class="input-group">
                    <label>Ciudad</label>
                    <p>
                      {{ detailItem.team_city }}
                    </p>
                </v-flex>

            </v-layout>

            <v-layout row mt-2>
                <v-flex xs12>
                    <h6 class="grey--text">Datos del Entrenador</h6>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 sm3 class="input-group">
                    <label>Nombre</label>
                    <p>
                      {{ detailItem.coach_name }}
                    </p>
                </v-flex>
                <v-flex xs12 sm3 class="input-group">
                    <label>Apellido</label>
                    <p>
                      {{ detailItem.coach_lastname }}
                    </p>
                </v-flex>
                <v-flex xs12 sm3 class="input-group">
                    <label>Celular</label>
                    <p>
                      {{ detailItem.coach_cellphone }}
                    </p>
                </v-flex>
                <v-flex xs12 sm3 class="input-group">
                    <label>Email</label>
                    <p>
                      {{ detailItem.coach_email }}
                    </p>
                </v-flex>
                <v-flex xs12 sm3 class="input-group">
                    <label>Pais</label>
                    <p>
                      {{ detailItem.coach_country }}
                    </p>
                </v-flex>
                <v-flex xs12 sm3 class="input-group">
                    <label>Estado</label>
                    <p>
                      {{ detailItem.coach_city }}
                    </p>
                </v-flex>

                <v-flex xs12 sm3 class="input-group">
                    <label>Codigo Postal</label>
                    <p>
                      {{ detailItem.coach_postal_code }}
                    </p>
                </v-flex>
            </v-layout>

            <v-layout row mt-2>
                <v-flex xs12>
                    <h6 class="grey--text">Social</h6>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 sm3 class="input-group">
                    <label>Facebook</label>
                    <p>
                      {{detailItem.fb}}
                    </p>
                </v-flex>
                <v-flex xs12 sm3 class="input-group">
                    <label>Instagram</label>
                    <p>
                      {{detailItem.instagram}}
                    </p>
                </v-flex>

            </v-layout>








          </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click.stop="detail=null">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


      <simple-numeric-input
        @confirm="confirmPriceDialog"
        ref="numbericinput"
        :dialog="priceDialog"
         :labelText="'Total a pagar ' + acceptRegistrationData.currency"
         :default="acceptRegistrationData.defaultPrice"
         positiveText="Aceptar">
       </simple-numeric-input>

    <v-layout row wrap>
      <v-flex xs6 md5 offset-md1 d-flex align-center>
        <h3 class="green--text headline mb-0">Registro de equipos</h3>
      </v-flex>

    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md10 offset-md1>
        <v-text-field
          box
          name="searchbar"
          label="Buscar registros"
          append-icon="search"
          color="green"
          v-model="filter"></v-text-field>
      </v-flex>
      <v-flex xs12 md10 offset-md1>
        <v-data-table
        :rows-per-page-items="[25,50,100]"
          :headers="headers"
          :items="getRegistrations"
          :search="filter"
          class="elevation-1"
          light
          :loading="tableLoading"
          rows-per-page-text="Filas por página"
          >
          <template slot="items" slot-scope="props">
            <td @click.stop="showDetail(props.item)" class="text-xs-left green--text">
                {{ getYear(props.item.registry_date) }}
            </td>
            <td class="text-xs-left grey--text">{{ props.item.team_name  }}</td>
            <td class="text-xs-left grey--text">{{ props.item.tournament_name }}</td>
            <td class="text-xs-left grey--text">{{ props.item.payment_status ? "Aprobado" : "Pendiente" }}</td>
            <td class="text-xs-left grey--text">
              {{getFormatedDate(props.item.registry_date)}}
            </td>
            <td class="text-xs-left">
              {{props.item.status == 'approved' ? getFormatedDate(props.item.approved_date) : ''}}
            </td>
            <td class="text-xs-left">
              <span v-if="props.item.payment_status">
                <span>ID:</span></br>
                <span>{{ props.item.payment_id  }}</span></br></br>
                <span>Fecha:</span></br>
                <span>{{ getFormatedDate(props.item.payment_at)  }}</span></br>
              </span>
            </td>
            <td class="text-xs-left">
              {{ props.item.deleted_at == null ? props.item.status : 'Archived' }}
            </td>
            <td v-if="props.item.deleted_at == null" class="text-xs-left">
              <v-btn outline @click="acceptRegistratios(props.item,true)" v-if="props.item.payment_status != true && props.item.status != 'approved' " color="primary" small light flat>Aceptar</v-btn>
              <v-btn outline @click="acceptRegistratios(props.item,false)" v-if="props.item.payment_status != true && props.item.status != 'rejected'"  color="error" small light flat>Rechazar</v-btn>
              <v-btn outline @click="markaAsPaid(props.item)" v-if="props.item.payment_status != true"  color="error" small light flat>Marcar como pagado</v-btn>
              <v-btn outline @click="archiveRegistratios(props.item.id)"  color="error" small light flat>Archivar</v-btn>
            </td>
            <td class="text-xs-left" v-if="props.item.deleted_at != null">

            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Bus from '@/components/bus'
import moment from 'moment'
import SimpleNumericInput from '@/components/helpers/modals/SimpleNumericInput'




export default {
  name: "TournamentRegistrations",
  data: () => ({
    priceDialog:false,
    detailItem: null,
    detail:false,
    acceptAndMarkAsPaid:false,
    filter: '',
    acceptRegistrationData:{},
    actionSelected: '',
    userSelected: [],
    // Muestra un pequeño loading encima de la tabla dependiendo de su valor (True, False)
    tableLoading: false,
    headers: [
      { text: 'Año', value: 'name', align: 'left' },
      { text: 'Equipo', value: 'email', align: 'left' },
      { text: 'Torneo', value: 'phone', align: 'left' },
      { text: 'Estado de pago', value: 'userType', align: 'left' },
      { text: 'Fecha de inscripción', value: 'status', align: 'left' },
      { text: 'Fecha de aprobación', value: 'status', align: 'left' },
      { text: 'Info del pago', value: 'status', align: 'left' },
      { text: 'Estado', value: 'status', align: 'left' },
      { text: 'Acciones', value: 'delete', align: 'left' }
    ]
  }),
  created() {
    //do something after creating vue instance
    this.loadTournamentRegistrations(this.$route.params.tournamentID)
  },
  mounted(){
    console.log("MOUNTED", this.$route.params.tournamentID)
  },
  computed: {
    ...mapGetters([
      'getRegistrations',
      'currentSession'
    ]),
    ...mapGetters('loading', [
      'isLoading',
      'anyLoading',
    ])
  },
  methods: {
    ...mapActions([
      'loadTournamentRegistrations',
      'goNewUser',
      'goEditUser',
      'removeUser',
      'activeUser',
      'resolveRegistrations',
      'acceptAndMarkAsPaidARegistration',
      'archiveRegistrations'
    ]),
    getYear(date){
      var localLocale = moment(date);
      moment.locale('es');
      localLocale.locale(false);
      return localLocale.format('YYYY')
    },
    getFormatedDate(date){
      var localLocale = moment(date);
      moment.locale('es');
      localLocale.locale(false);
      return localLocale.format('MMMM DD [del] YYYY [a] hh:mm a')
    },
    acceptRegistratios(reg,accept){

      this.acceptRegistrationData.defaultPrice = reg.tournament_price
      this.acceptRegistrationData.currency = reg.tournament_currency
      this.acceptRegistrationData.tournamentId = this.$route.params.tournamentID
      this.acceptRegistrationData.registrationId =  reg.id
      this.acceptRegistrationData.accepted = accept
      if(!accept){
        this.resolveRegistrations(this.acceptRegistrationData)
      }else{
        this.priceDialog = true
      }

    },
    markaAsPaid(reg){
      this.acceptRegistrationData.defaultPrice = reg.tournament_price
      this.acceptRegistrationData.currency = reg.tournament_currency
      this.acceptRegistrationData.tournamentId = this.$route.params.tournamentID
      this.acceptRegistrationData.registrationId =  reg.id


      this.acceptAndMarkAsPaid = true
      this.priceDialog = true
    },
    confirmPriceDialog(confirm,value){
      if(!confirm){this.priceDialog = false; return;}
      if(value && Number(value)>0){
        this.priceDialog = false
        this.acceptRegistrationData.ammount = Number(value)
        if(this.acceptAndMarkAsPaid){
          this.acceptAndMarkAsPaid = false
          this.acceptAndMarkAsPaidARegistration(this.acceptRegistrationData)
          return;
        }
        this.resolveRegistrations(this.acceptRegistrationData)
      }
    },
    archiveRegistratios(id,accept){

      let data = {
        tournamentId:this.$route.params.tournamentID,
        registrationId: id
      }
      console.log("archiveRegistratios",data)
      this.archiveRegistrations(data)
    },
    showDetail(item){
      this.detailItem = item
      this.detail = true
    }

  }

}
</script>

<style lang="css" scoped>
select{
  border: 1px solid;
  padding: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/tournaments/tournament_registration/tournamentRegistrations.vue